import Preloader from "../../components/custom/preloader/preloader.vue";
import FeedbackBox from "../../components/custom/feedbackBox/feedbackBox.vue";
import AdminNews from "../../components/custom/adminNews/admin-news.vue";
import AdminBanners from "../../components/custom/adminBanners/admin-banners.vue";
import News from "../news/news.vue";
import SingleNews from "../singleNews/singleNews.vue";
import mediaUploader from "../../components/custom/mediaUploader/mediaUploader.vue";

import _find from "lodash/find";
import _defaultsDeep from "lodash/defaultsDeep";

const moment = require("moment");

import {
  FEEDBACK_GET_USERS,
  FEEDBACK_GET_DATA,
  FEEDBACK_SET_DATA,
  SETTING_CHANGE_PRELOAD,
  FEEDBACK_SEND_MESSAGE,
  MEDIA_UPLOAD_FILE,
  MEDIA_DELETE_FILE,
  NEWS_DELETE_SINGLE,
  NEWS_GET_SINGLE,
  NEWS_EDIT_SINGLE,
  NEWS_SEND_SINGLE,
  BANNER_ADMIN_TOUR_LIST,
  BANNER_ADMIN_FILE_TOUR,
  INIT_DATA_CITIES_REF,
  BANNER_GET_TOUR,
  BANNER_TOUR,
  BANNER_TARIFF_ASSOCIATED_ORDER
} from "../../util/mutationTypes";

import {
  ROUTE_NAME_ADMIN_CURRENT,
  SENDER_INTERIOR,
  NEWS_NEW,
  NEWS_EDIT,
  NEWS_SEND,
  NEWS_COMMENT,
  NEWS_DELETE,
  ROUTE_ADMIN_BANNERS,
  ROUTE_NAME_NEWS,
  ROUTE_NAME_ADMIN,
  ROUTE_NAME_ADMIN_NEWS_CREATE,
  ROUTE_NAME_ADMIN_NEWS_EDIT,
  ROUTE_NAME_NEWS_SINGLE,
  ROUTE_NAME_ADMIN_BANNERS
} from "../../util/enumTypes";
import { setTimeout } from "timers";

export default {
  components: {
    Preloader,
    FeedbackBox,
    AdminNews,
    News,
    SingleNews,
    mediaUploader,
    AdminBanners,
    modalWindow: () =>
      import(
        /* webpackChunkName: "modalWindow" */
        "../../components/custom/modalWindow/modalWindow.vue"
      )
  },
  data() {
    return {
      activeTab: "Suggestion Box",
      singleUser: null,
      loadMessages: false,
      errorSendMessage: false,
      status: NEWS_NEW,
      tinymceLoaded: false,
      processLoading: false,
      showPreviewWindow: false,
      indexPreview: null,
      previewNews: null,
      sended: false,
      urls: [],
      form: {},
      news: {},
      cropieData: null,
      endpointError: NEWS_COMMENT,
      previewImage: "",
      previewGalleries: [],
      previewAttachments: [],
      modifiedFilesDescription: []
    };
  },
  computed: {
    users() {
      return this.$store.state.FeedbackStorage.users;
    },
    messages() {
      return this.$store.state.FeedbackStorage.messages;
    },
    lang() {
      return this.$store.state.SettingStorage.language.toLowerCase();
    },
    userId() {
      return this.$route.params.id;
    },
    errorMessage() {
      switch (this.endpointError) {
        case NEWS_COMMENT:
          return this.$t("error_send_comment_message");
          break;
        case NEWS_EDIT:
          return this.$t("news_error_edit");
          break;
        case NEWS_SEND:
          return this.$t("news_error_send");
          break;
        case NEWS_DELETE:
          return this.$t("news_error_delete");
          break;
        case ROUTE_ADMIN_BANNERS:
          return this.$t("prepare_tour_admin_error_delete");
      }
    },
    bannerList() {
      return this.$store.state.BannerStorage.adminPrepareTours || [];
    },
    tourTariffs() {
      let result = [];
      let tour = this.$store.state.BannerStorage.tour;
      if (tour) {
        tour.tarifPeriods.forEach(tp => {
          result.push({
            tariffId: tp.id,
            from: tp.from,
            to: tp.to,
            orderNumber: tp.orderNumber,
            originOrderNumber: tp.orderNumber,
            errorText: "",
            successText: "",
            show: tp.show
          });
        });
      }
      return result;
    },
    tourTariffAssociatedOrder() {
      return this.$store.state.BannerStorage.tariffAssociatedOrder;
    }
  },
  methods: {
    init() {
      this.$store.dispatch(FEEDBACK_GET_USERS).then(() => {
        if (this.$route.params.id) {
          this.getMessages();
          this.singleUser = _find(
            this.$store.state.FeedbackStorage.users,
            u => {
              return u.id == this.$route.params.id;
            }
          );
        } else {
          this.loadMessages = false;
        }
        this.tinymceLoaded = true;
        this.$store.commit(SETTING_CHANGE_PRELOAD, false);
      });

      if (this.$route.path.indexOf("news") !== -1) {
        this.activeTab = "News";
        if (this.$route.params.id) {
          this.status = NEWS_EDIT;
          this.loadNews(this.$route.params.id);
        }
      }

      if (this.$route.name === ROUTE_NAME_ADMIN_BANNERS) {
        this.getBannerList();
        this.activeTab = "Banners";
      }

      this.loadInitCity();
    },
    feedbackSendMessage() {
      this.$refs.feedbackBox.messageHandle();
    },
    loadNews(id) {
      this.$store.dispatch(NEWS_GET_SINGLE, { id }).then(news => {
        this.news = news;
        Object.assign(this.previewAttachments, news.attachments || []);
        Object.assign(this.previewGalleries, news.galaries || []);
      });
    },
    async loadInitCity() {
      if (!this.$store.state.InitDataStorage.citiesAndHotels.length) {
        this.$store.dispatch(INIT_DATA_CITIES_REF, this.lang);
      }
    },
    showSaveFailedError() {
      this.errorSendMessage = true;
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      setTimeout(() => {
        this.closeWindow();
      }, 5000);
    },

    handleTabClick(val) {
      if (val.name == "Suggestion Box") {
        this.$router.replace({ name: ROUTE_NAME_ADMIN });
      } else if (val.name == "Banners") {
        this.getBannerList();
        this.$router.replace({ name: ROUTE_NAME_ADMIN_BANNERS });
      } else if (this.status == NEWS_EDIT) {
        this.$router.replace({
          name: ROUTE_NAME_ADMIN_NEWS_EDIT,
          params: { id: this.news.newsId }
        });
      } else {
        this.$router.replace({ name: ROUTE_NAME_ADMIN_NEWS_CREATE });
      }
    },
    currentUser(user) {
      if (
        this.singleUser &&
        this.singleUser.id == user.id &&
        this.$route.params.id == user.id
      ) {
        return;
      }
      this.loadMessages = true;
      this.singleUser = user;
      this.$router.push({
        name: ROUTE_NAME_ADMIN_CURRENT,
        params: {
          lang: this.lang,
          id: user.id
        }
      });
      this.getMessages();
    },
    getMessages() {
      if (this.messages.length) this.$store.commit(FEEDBACK_SET_DATA, []);
      this.$store
        .dispatch(FEEDBACK_GET_DATA, {
          id: this.$route.params.id || this.singleUser.id
        })
        .then(() => {
          this.loadMessages = false;
          this.scrollMessageBlock();
        });
    },
    sendMessage(message) {
      let fileLinks = Object.assign([], this.urls);
      this.$store
        .dispatch(FEEDBACK_SEND_MESSAGE, {
          data: {
            text: message,
            userId: this.singleUser.id,
            lang: this.lang,
            userName: this.singleUser.name,
            sender: SENDER_INTERIOR,
            messageDate: new Date(),
            fileLinks
          }
        })
        .then(resp => {
          if (resp.data.error || resp.data.code) {
            this.endpointError = NEWS_COMMENT;
            this.errorSendMessage = true;
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
            this.sended = false;
          } else {
            this.$store
              .dispatch(FEEDBACK_GET_DATA, { id: this.singleUser.id })
              .then(() => {
                this.sended = true;
                this.scrollMessageBlock();
              });
          }
        });
    },
    printMessages(data) {
      let result = "";
      for (let message of data) {
        result += `< ${moment(message.messageDate).format(
          "DD-MM-YYYY HH:mm:ss"
        )} > <strong>${message.userName}</strong>: ${
          message.text
        } <br /><br />`;
      }
      let printWindow = window.open();
      printWindow.document.open("text/plain");
      printWindow.document.write(result);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },
    scrollMessageBlock() {
      setTimeout(() => {
        if (this.messages.length) {
          let block = document.querySelector(".messages-block");
          block.scrollTop = block.scrollHeight;
        }
      });
    },
    closeWindow() {
      if (this.errorSendMessage) this.errorSendMessage = false;
      else this.showPreviewWindow = false;
      this.indexPreview = null;
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    },
    deleteNews(id) {
      this.$store
        .dispatch(NEWS_DELETE_SINGLE, { id, lang: this.lang })
        .then(data => {
          if (data.code || data.error) {
            this.endpointError = NEWS_DELETE;
            this.showSaveFailedError();
            return;
          }
          this.$router.push({ name: ROUTE_NAME_NEWS });
        });
    },
    showPreview(args) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      this.indexPreview = args.index;
      this.previewNews = _defaultsDeep({}, args.news);
      this.previewNews.created =
        this.previewNews.created || moment().format().replace(/\+.*/, "");
      this.previewNews.previewPhoto =
        this.previewImage || this.previewNews.previewPhoto;
      this.previewNews.galariesPreview = this.previewGalleries;
      this.previewNews.attachmentsPreview = this.previewAttachments;
      this.showPreviewWindow = true;
    },
    croppieResult(blob) {
      this.previewImage = window.URL.createObjectURL(blob);
      this.cropieData = new FormData();
      this.cropieData.append("file", blob);
      this.cropieData.append("type", "FILE_TYPE_NEWS_PREVIEW");
      this.cropieData.append("description", "");
      this.cropieData.append("fileName", blob.name);
    },
    croppieResultRemove() {
      this.cropieData = null;
      this.previewImage = "";
    },

    async submit(data) {
      let form = data.news;
      if (this.cropieData) {
        try {
          let data = await this.$store.dispatch(MEDIA_UPLOAD_FILE, {
            formData: this.cropieData,
            lang: this.lang
          });
          form.previewPhoto = data.url;
        } catch (err) {
          console.log(err);
        }
      }

      if (form.newsId) {
        let id = form.newsId;
        delete form.newsId;
        this.$store
          .dispatch(NEWS_EDIT_SINGLE, { news: form, lang: this.lang, id })
          .then(data => {
            if (data.code || data.error) {
              this.endpointError = NEWS_EDIT;
              this.showSaveFailedError();
              return;
            }
            this.$router.push({ name: ROUTE_NAME_NEWS_SINGLE, params: { id } });
          })
          .catch(err => {
            this.endpointError = NEWS_EDIT;
            this.showSaveFailedError();
          });
      } else {
        this.$store
          .dispatch(NEWS_SEND_SINGLE, { news: form, lang: this.lang })
          .then(data => {
            this.$router.push({ name: ROUTE_NAME_NEWS });
          })
          .catch(err => {
            this.endpointError = NEWS_SEND;
            this.showSaveFailedError();
          });
      }
    },
    getBannerList() {
      this.$store.dispatch(BANNER_ADMIN_TOUR_LIST, { lang: this.lang });
    },
    saveRelationBannerTour(data) {
      this.$store
        .dispatch(BANNER_ADMIN_FILE_TOUR, { lang: this.lang, data })
        .then(resp => {
          this.getBannerList();
        })
        .catch(e => {
          this.showSaveFailedError();
          this.getBannerList();
        });
    },
    deleteRelationBannerTour(fileId) {
      this.$store
        .dispatch(MEDIA_DELETE_FILE, { lang: this.lang, fileId })
        .then(resp => {
          this.getBannerList();
        })
        .catch(e => {
          this.endpointError = ROUTE_ADMIN_BANNERS;
          this.showSaveFailedError();
          this.getBannerList();
        });
    },
    fixTourClick(tourId) {
      this.$store.dispatch(BANNER_GET_TOUR, {
        tourId,
        discountDate: 0,
        lang: this.lang
      });
    },
    adminBannerCloseModal() {
      this.$store.commit(BANNER_TOUR, null);
    },
    modalSaveRelatedTariffOrder(obj) {
      this.$store.commit(BANNER_TARIFF_ASSOCIATED_ORDER, []);
      this.$store.dispatch(BANNER_TARIFF_ASSOCIATED_ORDER, obj);
    }
  },
  created() {
    this.$store.commit(SETTING_CHANGE_PRELOAD, true);
    this.loadMessages = true;
  },
  mounted() {
    this.init();
  },
  watch: {
    lang(val) {
      this.$router.replace({ params: { lang: val } });
    }
  }
};
